export default __webpack_public_path__ + "static/media/footer-background.e3df3a64.png";